import { addBreadcrumb } from '@sentry/react'
import { createRouter } from '@tanstack/react-router'

import { RouterErrorPage } from './pages/error/RouterErrorPage'
import { RouterNotFoundErrorPage } from './pages/error/RouterNotFoundErrorPage'
import { isSupportEmbed } from './pages/support/embed/piloteFrame'
import { logPageView } from './analytics'
import { routeTree } from './routeTree.gen'

export const router = createRouter({
  routeTree,
  context: {
    /* eslint-disable @typescript-eslint/no-non-null-assertion */
    queryClient: undefined!,
    auth: undefined!,
    /* eslint-enable @typescript-eslint/no-non-null-assertion */
  },
  defaultNotFoundComponent: RouterNotFoundErrorPage,
  defaultErrorComponent: RouterErrorPage,
  defaultStaleTime: Infinity,
})

router.subscribe('onBeforeLoad', (event) => {
  const { toLocation, pathChanged } = event

  if (pathChanged) {
    addBreadcrumb({
      category: 'navigation',
      message: `Route changed to ${toLocation.pathname}`,
      level: 'info',
      data: {
        ...toLocation,
      },
    })
  }
})

router.subscribe('onResolved', ({ pathChanged }) => {
  const leafMatch = router.state.matches.at(-1)
  // Pilote loads the support panel in a hidden frame on each of its pages: the panel counts its
  // view when it opens, in usePiloteFrame.
  if (pathChanged && leafMatch && !isSupportEmbed()) {
    logPageView(leafMatch.fullPath)
  }
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
